import Link from 'next/link';

const B2B_PRODUCT_LINKS = [
  { href: '/business/payments', label: 'Payments' },
  { href: '/business/retail-finance', label: 'Retail Finance' },
  { href: '/business/auto-finance', label: 'Auto Finance' },
  { href: '/business/partnerships', label: 'Partnerships' },
];

type Props = {
  currentPath: string;
};

export const B2BCrossLinks = ({ currentPath }: Props) => {
  const links = B2B_PRODUCT_LINKS.filter(({ href }) => href !== currentPath);

  if (!links.length) {
    return null;
  }

  return (
    <nav aria-label="Related Zopa Business pages" className="sr-only">
      {links.map(({ label, href }) => (
        <Link href={href} key={href}>
          {label}
        </Link>
      ))}
    </nav>
  );
};
